"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguageContext = exports.LanguageContextProvider = void 0;
var react_1 = __importStar(require("react"));
var LanguageContext = (0, react_1.createContext)();
var LanguageContextProvider = function (_a) {
    var children = _a.children, localize = _a.localize, storage = _a.storage, _b = _a.options, options = _b === void 0 ? {} : _b;
    var setIdCallback = options.setIdCallback, logErrorCallback = options.logErrorCallback;
    var _c = __read((0, react_1.useState)('en'), 2), languageId = _c[0], setLanguageId = _c[1];
    var supportedLanguages = localize.getSupportedLanguages();
    var FALLBACK_LANGUAGE_ID = 'en';
    var INVALID_ID_TEXT = 'invalid languageId in localization-util';
    var LANGUAGE_LOCAL_STORAGE_KEY = 'cvgLanguageId';
    var _getId = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, storage.getItem(LANGUAGE_LOCAL_STORAGE_KEY)];
                case 1: return [2 /*return*/, (_a.sent()) || FALLBACK_LANGUAGE_ID];
            }
        });
    }); };
    var _setId = function (languageId) { return __awaiter(void 0, void 0, void 0, function () {
        var isSupportedLanguage;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isSupportedLanguage = supportedLanguages.map(function (language) { return language.id; }).includes(languageId);
                    if (!isSupportedLanguage) return [3 /*break*/, 2];
                    return [4 /*yield*/, storage.setItem(LANGUAGE_LOCAL_STORAGE_KEY, languageId)];
                case 1:
                    _a.sent();
                    if (setIdCallback)
                        setIdCallback(languageId);
                    return [3 /*break*/, 3];
                case 2:
                    if (logErrorCallback) {
                        logErrorCallback("".concat(INVALID_ID_TEXT, ".setId: ").concat(languageId));
                    }
                    else {
                        console.error('Invalid locale for setID:', languageId);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    (0, react_1.useEffect)(function () {
        var loadId = function () { return __awaiter(void 0, void 0, void 0, function () {
            var id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, _getId()];
                    case 1:
                        id = _a.sent();
                        setLanguageId(id);
                        return [2 /*return*/];
                }
            });
        }); };
        loadId();
    }, []);
    var getTranslation = function (key) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        return localize.getValue.apply(localize, __spreadArray([key, languageId], __read(params), false));
    };
    var getPluralTranslation = function (count, singleKey, pluralKey) {
        return localize.getPluralValue(count, singleKey, pluralKey, languageId);
    };
    var handleLanguageChange = function (language) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: 
                // Set local storage first, so when state update causes a re-render, and the new language keys are used
                return [4 /*yield*/, _setId(language)];
                case 1:
                    // Set local storage first, so when state update causes a re-render, and the new language keys are used
                    _a.sent();
                    setLanguageId(language);
                    return [2 /*return*/];
            }
        });
    }); };
    var context = {
        getTranslation: getTranslation,
        getPluralTranslation: getPluralTranslation,
        handleLanguageChange: handleLanguageChange,
        languageId: languageId,
        supportedLanguages: supportedLanguages
    };
    return react_1.default.createElement(LanguageContext.Provider, { value: context }, children);
};
exports.LanguageContextProvider = LanguageContextProvider;
var useLanguageContext = function () {
    return (0, react_1.useContext)(LanguageContext);
};
exports.useLanguageContext = useLanguageContext;
//# sourceMappingURL=index.js.map